<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="100px">
			<h1>Reminder</h1>
			<el-form-item label="Email:">
				<el-input placeholder="Your email address" type="email" v-model.trim="credentials.email" @input="$v.credentials.email.$touch()" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.email.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.email.required">
						Field is required.
					</span>
				<span class="el-form-item__error" v-if="!$v.credentials.email.email" :disabled="app.isLoading">
						Must be a valid email.
					</span>
				</span>
			</el-form-item>
			<hr>
			<p>
				<el-button type="primary" @click="sendReminder()" :disabled="$v.$invalid || app.isLoading" :loading="app.isLoading">Send Reminder</el-button>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import router from "@/router";
import axios from "axios";
import store from "@/utils/store";
import { REMINDER_URL } from "@/config";

export default {
	name: "reminder",
	data() {
		return {
			app: store,
			credentials: {
				email: ""
			}
		};
	},
	validations: {
		credentials: {
			email: {
				required,
				email
			}
		}
	},
	methods: {
		sendReminder() {
			if (this.$v.$invalid) return;
			let _self = this;
			axios
				.post(REMINDER_URL, this.$data.credentials)
				.then(function(response) {
					router.push("/");
					return (_self.app.messages = [response.data.message]);
				})
				.catch(function(error) {
					let res = error.response;
					return (_self.app.messages = [res.data.message]);
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// Reminder.vue?664e1f44